module.exports = {
  assetPrefix: `/devices`,
  trailingSlash: `ignore`,
  siteMetadata: {
    baseUrl: `https://crunchyroll.com`,
    url: `https://crunchyroll.com/devices`,
    title: `Crunchyroll - Crunchyroll-Ready Devices`,
    description: `Get a complete list of all the Crunchyroll-Ready devices to watch all your favorite anime`,
    banner: {
      url: `https://crunchyroll.com/devices/default-banner.jpg`,
      width: `1080`,
      height: `565`,
    },
  },
  plugins: [
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/images`,
      },
    },
    `gatsby-plugin-emotion`,
    `gatsby-plugin-react-helmet`,
    `gatsby-transformer-sharp`,
    {
      resolve: `gatsby-plugin-sharp`,
      options: {
        defaults: {
          formats: [`auto`, `webp`],
          quality: 80,
        },
      },
    },
    `gatsby-plugin-image`,
  ],
}
